import type { ComponentType } from 'react';
import { ChangePasswordPage } from '@/pages/ChangePasswordPage';
import { AttendancePage } from '@/pages/admin/AttendancePage';
import { AuditLogsPage } from '@/pages/admin/AuditLogsPage';
import { DailyLogsPage } from '@/pages/admin/DailyLogsPage';
import { DashboardPage } from '@/pages/admin/DashboardPage';
import { DrawingsPage } from '@/pages/admin/DrawingsPage';
import { HiddenWorksPage } from '@/pages/admin/HiddenWorksPage';
import { OrgsPage } from '@/pages/admin/OrgsPage';
import { PurchasesPage } from '@/pages/admin/PurchasesPage';
import { RolesPage } from '@/pages/admin/RolesPage';
import { SchedulePage } from '@/pages/admin/SchedulePage';
import { SiteDetailPage } from '@/pages/admin/SiteDetailPage';
import { SitesPage } from '@/pages/admin/SitesPage';
import { UsersPage } from '@/pages/admin/UsersPage';
import { MePage } from '@/pages/mobile/MePage';
import { MobileHomePage } from '@/pages/mobile/MobileHomePage';
import { PunchPage } from '@/pages/mobile/PunchPage';
import { ReviewPage } from '@/pages/mobile/ReviewPage';
import { SystemPage } from '@/pages/mobile/SystemPage';
import type { PageKey } from './types';

/**
 * 路由表里的页面名 → 组件（CR-040）。
 *
 * 单独一个文件：registry.ts / logic.ts 不能引 React（穷举测试要在 node 里跑），
 * 真正渲染时由 App.tsx 的 RegistryPage 查这张表。`Record<PageKey, …>` 保证不会漏一个。
 */
export const PAGES: Record<PageKey, ComponentType> = {
  SitesPage,
  UsersPage,
  RolesPage,
  OrgsPage,
  AuditLogsPage,
  DashboardPage,
  SiteDetailPage,
  DrawingsPage,
  SchedulePage,
  DailyLogsPage,
  PurchasesPage,
  AttendancePage,
  HiddenWorksPage,
  MobileHomePage,
  PunchPage,
  ReviewPage,
  MePage,
  SystemPage,
  ChangePasswordPage,
};
